<template>
  <v-container fluid class="px-16 my-4">
    <FormulaBar msg=""/>
      <v-row>
        <v-col
          cols="7"
          class="px-0 my-6"
        >
          <FormulaCard />
        </v-col>
        <v-col
          cols="5"
          class="my-auto"
        >
          <LighteningBoltIndicater />
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
// @ is an alias to /src
import FormulaBar from '@/components/Mixer/FormulaBar.vue';
import FormulaCard from '@/components/Mixer/FormulaCard.vue';
import LighteningBoltIndicater from '@/components/Mixer/LighteningBoltIndicater.vue';

export default {
  name: 'Home',
  components: {
    FormulaBar,
    FormulaCard,
    LighteningBoltIndicater
  }
}
</script>

<style scoped>

</style>